import Map from '../views/Map.vue'

export default [
  {
    path: '/school-rank-vis/',
    name: 'map',
    component: Map
  }
]
